import Model from "./Model.js";

/**
 *  An `IsaasJob` extracts data from an ERP using an iSaaS Connector.
 *  A Job imports the data into the iSaaS Service and if needed performs data
 *  transformations for a given date range.
 *
 * @param {string} spec.id - Identifier of the job
 * @param {string} spec.authenticateUrl - URL to authenticate the user used by the importer
 * @param {boolean} spec.isAuthenticationRequired - True when iSaaS asks for authentication
 */
export default class IsaasJob extends Model {
	constructor({ id, authenticateUrl, isAuthenticationRequired } = {}) {
		super(...arguments);
		this._id = id;
		this._authenticateUrl = authenticateUrl;
		this._isAuthenticationRequired = isAuthenticationRequired;
	}

	getId() {
		return this._id;
	}

	getAuthenticateUrl() {
		return this._authenticateUrl;
	}

	isAuthenticationRequired() {
		return this._isAuthenticationRequired;
	}

	_serializedProperties() {
		return {
			id: this._id,
			authenticateUrl: this._authenticateUrl,
			isAuthenticationRequired: this._isAuthenticationRequired,
		};
	}
}
